<template>
  <div class="shift-calendar-container">
    <div class="shift-calendar-header ion-text-center">
      <div v-if="error">{{ error }}</div>
      <ion-text color="light" class="h-f-m"
        >Tap on a date to view details</ion-text
      >
    </div>

    <ion-slides pager="false" :options.prop="calendarOptions">
      <ion-slide v-for="(date, index) in dates" v-bind:key="index">
        <ion-card
          class="ion-margin-vertical shift-calendar-card"
          @click="showCalendarItems(date.key)"
          color="dark"
        >
          <div class="shift-calendar-badge" v-if="itemsCount(date.key) > 0">
            {{ itemsCount(date.key) }}
          </div>
          <div class="shift-calendar-date-container">
            <ion-card-subtitle
              v-html="date.day"
              class="shift-calendar-date-subtitle"
            ></ion-card-subtitle>
            <ion-card-title
              v-html="date.date"
              class="h-f-b shift-calendar-date-title"
            ></ion-card-title>
            <ion-card-subtitle
              v-html="date.month"
              class="shift-calendar-date-subtitle"
            ></ion-card-subtitle>
          </div>
        </ion-card>
      </ion-slide>
    </ion-slides>

    <div class="shift-calendar-items-container" v-if="itemsToShow">
      <ion-item v-if="items.length === 0" color="warning">
        <ion-label>There are no shifts on this date.</ion-label>
      </ion-item>

      <ion-list v-if="items.length > 0" lines="full" class="ion-no-padding">
        <ion-item color="dark">
          <ion-label>{{ activeDate }}</ion-label>
          <font-awesome-icon
            slot="end"
            icon="times"
            @click="close"
          ></font-awesome-icon>
        </ion-item>

        <ion-item
          v-for="(shift, index) in items"
          v-bind:key="index"
          v-bind:color="shift.verification_stage | verificationColor"
        >
          <font-awesome-icon
            slot="start"
            v-bind:icon="shift.type | shiftTypeIcon"
          ></font-awesome-icon>

          <ion-label
            >{{ shift.type == "CAM_SHIFT" ? "Cam Shift" : "" }}
            {{ shift.type == "TV_SHIFT" ? "TV Shift" : "" }}
            - {{ shift.start_time | formatTime("h:mm a") }} -
            {{ shift.end_time | formatTime("h:mm a") }}</ion-label
          >
        </ion-item>
      </ion-list>
    </div>
  </div>
</template>

<script>
// Add more items to slider - https://github.com/nolimits4web/Swiper/blob/master/demos/290-dynamic-slides.html
import moment from "moment";
import shiftsApiService from "../services/ShiftsApi";

const paramDateFormat = "YYYY-MM-DD";
const daysEachSide = 40;
const initialSlide = daysEachSide;

export default {
  name: "shifts-calendar",
  data() {
    return {
      dates: [],
      shifts: [],
      items: [],
      itemsToShow: false,
      activeDate: "",
      calendarOptions: {
        initialSlide: initialSlide,
        slidesPerView: 3.5,
        centeredSlides: true,
        spaceBetween: 1,
      },
      loading: false,
      error: false,
    };
  },

  mounted() {
    this.loading = true;
    let beginDate = moment().subtract(daysEachSide, "days");
    let finishDate = moment().add(daysEachSide, "days");
    let startDate = beginDate.format(paramDateFormat);
    let endDate = finishDate.format(paramDateFormat);

    while (beginDate < finishDate) {
      let formattedDate = {
        key: moment(beginDate).format("YYYY-MM-DD"),
        day: moment(beginDate).format("ddd"),
        date: moment(beginDate).format("Do"),
        month: moment(beginDate).format("MMM"),
      };

      this.dates.push(formattedDate);
      beginDate = moment(beginDate).add(1, "days");
    }

    shiftsApiService
      .get(startDate, endDate)
      .then((shifts) => {
        this.shifts = shifts;
        this.loading = false;
      })
      .catch((error) => {
        this.error = error;
      });
  },
  methods: {
    itemsCount(key) {
      let hasShift = this.shifts.filter((shift) => shift.cellcast_date === key);

      return hasShift.length;
    },

    showCalendarItems(date) {
      // To target clickedon item use event.target
      // console.log(event.currentTarget);
      // event.currentTarget.style.setProperty("--background", "#3880ff");

      this.activeDate = moment(date).format("dddd Do MMMM YYYY");
      this.itemsToShow = !this.itemsToShow;

      this.items = this.shifts.filter((shift) => shift.cellcast_date === date);
    },
    close() {
      this.itemsToShow = !this.itemsToShow;
      this.items = [];
      this.activeDate = "";
    },
  },

  filters: {
    formatTime(value, format) {
      if (!value) {
        return;
      }

      return moment
        .utc(value)
        .local()
        .format(format);
    },

    shiftTypeIcon(value) {
      if (!value) {
        return;
      }

      let type = "tv";

      if (value === "CAM_SHIFT") {
        type = "video";
      }
      return type;
    },

    verificationColor(value) {
      if (!value) {
        return;
      }

      switch (value) {
        case "VERIFIED":
          return "success";
        case "WAITING_FOR_CALCULATION":
          return "tertiary";
        case "WAITING_FOR_VERIFICATION":
          return "warning";
        case "CANCELLED":
          return "danger";
        default:
          return "secondary";
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.shift-calendar-container {
  background: var(--ion-color-dark);
}

.shift-calendar-header {
  padding: 8px;
}

.shift-calendar-card {
  border-radius: 50%;
  border: 1px solid var(--ion-color-tertiary);
  overflow: visible;
  width: 100%;
  padding-bottom: 80%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.shift-calendar-badge {
  background: var(--ion-color-tertiary);
  border-radius: 50%;
  padding: 6px 8px 1px 8px;
  position: absolute;
  right: 4px;
  top: -4px;
}

.shift-calendar-date-container {
  position: absolute;
  top: 20%;
}

.shift-calendar-date-subtitle {
  font-size: 14px;
}

.shift-calendar-date-title {
  font-size: 16px;
  margin: 3px 0;
}

.shift-calendar-items-container {
  background: #f4f5f8;
}

.shift-calendar-items-header {
  padding: 8px;
  background: #f4f5f8;
  border-bottom: 1px solid rgba(0, 0, 0, 0.3);
}

.shift-calendar-items-detail {
  font-size: 14px;
}
</style>
